module.exports = __webpack_public_path__ + "static/media/covid-dha.555cc357.svg";